import { Head } from "@inertiajs/react";

export default function Favicon() {
    return (
        <Head>
            <link rel="icon" type="image/png" href="/favicon/favicon.png" sizes="128x128" />
            <link rel="icon" type="image/png" href="/favicon/favicon-96x96.png" sizes="96x96" />
            <link rel="shortcut icon" href="/favicon/favicon.ico" />
            <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
            <meta name="apple-mobile-web-app-title" content="NOVA" />
            <link rel="manifest" href="/favicon/site.webmanifest" />
        </Head>
    );
}